var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    {
      staticClass: "user-info-section",
      attrs: { "aria-busy": _vm.loadState === "loading" },
    },
    [
      _c("div", { staticClass: "header" }, [
        _c("h2", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("myPage.userInfo.title"))),
        ]),
        _c(
          "button",
          {
            staticClass: "update-link",
            attrs: { type: "button", disabled: _vm.loadState !== "loaded" },
            on: { click: _vm.onClickUpdate },
          },
          [_vm._v(" " + _vm._s(_vm.$t("myPage.userInfo.update")) + " ")]
        ),
      ]),
      _vm.showEditDialog
        ? _c("my-page-user-info-edit-dialog", {
            attrs: { profile: _vm.profile, "nola-penname": _vm.nolaPenname },
            on: {
              close: function ($event) {
                _vm.showEditDialog = false
              },
              updated: _vm.onUpdated,
            },
          })
        : _vm._e(),
      _vm.loadState === "error"
        ? _c("p", { staticClass: "load-error", attrs: { role: "alert" } }, [
            _vm._v(_vm._s(_vm.$t("myPage.userInfo.loadError"))),
          ])
        : _c("div", { staticClass: "fields" }, [
            _c("div", { staticClass: "field" }, [
              _c("p", { staticClass: "field-label" }, [
                _vm._v(_vm._s(_vm.$t("myPage.userInfo.name"))),
              ]),
              _vm.loadState === "loading"
                ? _c("span", {
                    staticClass: "skeleton-text skeleton-field-value",
                    attrs: { "aria-hidden": "true" },
                  })
                : _c(
                    "p",
                    {
                      staticClass: "field-value",
                      class: { "is-unset": _vm.isUnset(_vm.displayName) },
                    },
                    [_vm._v(_vm._s(_vm.displayOrUnset(_vm.displayName)) + " ")]
                  ),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("p", { staticClass: "field-label" }, [
                _vm._v(_vm._s(_vm.$t("myPage.userInfo.nameKana"))),
              ]),
              _vm.loadState === "loading"
                ? _c("span", {
                    staticClass: "skeleton-text skeleton-field-value",
                    attrs: { "aria-hidden": "true" },
                  })
                : _c(
                    "p",
                    {
                      staticClass: "field-value",
                      class: { "is-unset": _vm.isUnset(_vm.displayNameKana) },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.displayOrUnset(_vm.displayNameKana)) + " "
                      ),
                    ]
                  ),
            ]),
            _c(
              "div",
              { staticClass: "field" },
              [
                _c("p", { staticClass: "field-label" }, [
                  _vm._v(_vm._s(_vm.$t("myPage.userInfo.penname"))),
                ]),
                _vm.loadState === "loading"
                  ? _c("span", {
                      staticClass: "skeleton-text skeleton-field-value",
                      attrs: { "aria-hidden": "true" },
                    })
                  : [
                      _vm.pennames.length
                        ? _c(
                            "ul",
                            { staticClass: "penname-list" },
                            _vm._l(_vm.pennames, function (penname, index) {
                              return _c(
                                "li",
                                {
                                  key: `${penname}-${index}`,
                                  staticClass: "penname-item",
                                },
                                [
                                  index === 0
                                    ? _c("icon-star", {
                                        staticClass: "penname-star",
                                      })
                                    : _c("span", {
                                        staticClass: "penname-bullet",
                                        attrs: { "aria-hidden": "true" },
                                      }),
                                  _c("span", [_vm._v(_vm._s(penname))]),
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _c("p", { staticClass: "field-value is-unset" }, [
                            _vm._v(_vm._s(_vm.$t("common.unset"))),
                          ]),
                    ],
              ],
              2
            ),
            _c("div", { staticClass: "field" }, [
              _c("p", { staticClass: "field-label" }, [
                _vm._v(_vm._s(_vm.$t("myPage.userInfo.phone"))),
              ]),
              _vm.loadState === "loading"
                ? _c("span", {
                    staticClass: "skeleton-text skeleton-field-value",
                    attrs: { "aria-hidden": "true" },
                  })
                : _c(
                    "p",
                    {
                      staticClass: "field-value",
                      class: { "is-unset": _vm.isUnset(_vm.displayPhone) },
                    },
                    [_vm._v(_vm._s(_vm.displayOrUnset(_vm.displayPhone)) + " ")]
                  ),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("p", { staticClass: "field-label" }, [
                _vm._v(_vm._s(_vm.$t("myPage.userInfo.gender"))),
              ]),
              _vm.loadState === "loading"
                ? _c("span", {
                    staticClass:
                      "skeleton-text skeleton-field-value skeleton-field-value-short",
                    attrs: { "aria-hidden": "true" },
                  })
                : _c(
                    "p",
                    {
                      staticClass: "field-value",
                      class: { "is-unset": _vm.isUnset(_vm.displayGender) },
                    },
                    [_vm._v(_vm._s(_vm.displayOrUnset(_vm.displayGender)))]
                  ),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("p", { staticClass: "field-label" }, [
                _vm._v(_vm._s(_vm.$t("myPage.userInfo.birthdate"))),
              ]),
              _vm.loadState === "loading"
                ? _c("span", {
                    staticClass: "skeleton-text skeleton-field-value",
                    attrs: { "aria-hidden": "true" },
                  })
                : _c(
                    "p",
                    {
                      staticClass: "field-value",
                      class: { "is-unset": _vm.isUnset(_vm.displayBirthdate) },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.displayOrUnset(_vm.displayBirthdate)) + " "
                      ),
                    ]
                  ),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("p", { staticClass: "field-label" }, [
                _vm._v(_vm._s(_vm.$t("myPage.emailAddressLabel"))),
              ]),
              _vm.loadState === "loading"
                ? _c("span", {
                    staticClass:
                      "skeleton-text skeleton-field-value skeleton-field-value-wide",
                    attrs: { "aria-hidden": "true" },
                  })
                : _c(
                    "p",
                    {
                      staticClass: "field-value",
                      class: { "is-unset": _vm.isUnset(_vm.email) },
                    },
                    [_vm._v(_vm._s(_vm.displayOrUnset(_vm.email)))]
                  ),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("p", { staticClass: "field-label" }, [
                _vm._v(_vm._s(_vm.$t("myPage.userInfo.userId"))),
              ]),
              _vm.loadState === "loading"
                ? _c("span", {
                    staticClass:
                      "skeleton-text skeleton-field-value skeleton-field-value-wide",
                    attrs: { "aria-hidden": "true" },
                  })
                : _c(
                    "p",
                    {
                      staticClass: "field-value",
                      class: { "is-unset": _vm.isUnset(_vm.userId) },
                    },
                    [_vm._v(_vm._s(_vm.displayOrUnset(_vm.userId)))]
                  ),
              _c("p", { staticClass: "field-note" }, [
                _vm._v(_vm._s(_vm.$t("myPage.userIdNote"))),
              ]),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }